import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { usePlayer } from "@/lib/usePlayer";

const API_BASE = (process.env.REACT_APP_BACKEND_URL || "") + "/api";
const PlayerContext = createContext(null);

export function PlayerProvider({ children }) {
  const player = usePlayer();
  // Live count for the playing station — zero-vs-unknown: null until a
  // measurement doc exists; never coerced to 0.
  const [liveCount, setLiveCount] = useState(null);

  useEffect(() => {
    if (!player.playingId) { setLiveCount(null); return; }
    let stop = false;
    const poll = () => axios.get(`${API_BASE}/stations/${player.playingId}/realtime`)
      .then((r) => {
        if (stop) return;
        const rt = r.data || {};
        setLiveCount(rt.estimated_total_people != null
          ? { people: rt.estimated_total_people,
              label: rt.confidence_label || rt.data_source || "MODEL",
              as_of: rt.updated_at || null }
          : null);
      }).catch(() => {});
    poll();
    const t = setInterval(poll, 60000);
    return () => { stop = true; clearInterval(t); };
  }, [player.playingId]);

  return (
    <PlayerContext.Provider value={{ ...player, liveCount }}>
      {children}
    </PlayerContext.Provider>
  );
}

export function usePlayerCtx() {
  return useContext(PlayerContext);
}
